import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteAPIKeyRPC } from "./deleteApiKeyRPC";

export class DeleteAPIKeyRPCClientImpl extends DeleteAPIKeyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteAPIKeyRPC.Request): Promise<LeoRPCResult<DeleteAPIKeyRPC.Response, DeleteAPIKeyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "external-public-apis/DeleteAPIKey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteAPIKeyRPC.ResponseDTO,
      DeleteAPIKeyRPC.Errors.ErrorsDTO,
      DeleteAPIKeyRPC.Response,
      DeleteAPIKeyRPC.Errors.Errors
    >(
      response,
      "external-public-apis/DeleteAPIKey",
      DeleteAPIKeyRPC.Response.fromDTO,
      DeleteAPIKeyRPC.Errors.fromDTO
    );
  }
}
